<div class="search-container">
    <div
        class="search-overlay"
        (click)="closeModal()"></div>

    <div
        class="search-box"
        [ngClass]="{ 'no-content-box': noSearchResults }">
        <div class="search-input-container">
            <div class="search-input-box">
                <button
                    class="back-btn"
                    (click)="closeModal()">
                    <img src="assets/images/svg/arrow-down.svg" />
                </button>
                <div
                    class="search-input"
                    tabindex="0">
                    <div class="search-icon">
                        <img
                            src="assets/images/svg/search-white.svg"
                            width="20"
                            height="20"
                            alt="" />
                    </div>
                    <input
                        (focus)="clearPlaceholder()"
                        (blur)="restorePlaceholder()"
                        (keydown)="handleKeydown($event)"
                        (input)="toggleClearButton()"
                        [(ngModel)]="searchText"
                        class="search-bar"
                        [placeholder]="placeholderText"
                        type="text" />

                    @if (showClearButton) {
                        <button
                            class="clear-button"
                            (click)="clearSearch()">
                            <img src="assets/images/svg/x-casino.svg" />
                        </button>
                    }
                </div>

                @if (showFilter) {
                    <button
                        type="button"
                        class="filter-btn"
                        (click)="openCasinoFilter()">
                        <img
                            src="assets/images/svg/filter-check.svg"
                            width="20"
                            height="20"
                            alt="" />
                        <span>{{ 'casino_page.provider_text' | transloco }}</span>
                    </button>
                }
                @if (showCloseButton) {
                    <button
                        class="close-btn"
                        (click)="closeModal()">
                        {{ 'casino_page.close_button' | transloco }}
                    </button>
                }
            </div>
            @if (selectedProviders.length > 0) {
                <div class="selected-providers">
                    @for (provider of selectedProviders; track provider) {
                        <div
                            class="remove-provider"
                            (click)="removeProvider(provider)">
                            {{ provider.toUpperCase() }}
                            <img
                                src="assets/images/svg/close.svg"
                                alt=""
                                width="8"
                                height="8" />
                        </div>
                    }
                </div>
            }

            <div class="content">
                <div class="content-container">
                    <div
                        class="content-title"
                        [ngClass]="{ 'no-content': noSearchResults }">
                        <h2>{{ 'casino_page.more_games' | transloco }}</h2>
                    </div>

                    <div
                        class="content-items"
                        [ngClass]="{ 'no-search': noSearchResults }">
                        @if (!loadingGames) {
                            @if (noSearchResults) {
                                <div class="row">
                                    <div class="col-12 text-center no-games-container">
                                        <div class="no-result">
                                            <img
                                                src="assets/images/svg/sad-face.svg"
                                                alt="" />
                                            <div>
                                                <p class="no-matches-text">
                                                    {{ 'casino_page.found_no_matches' | transloco }}
                                                </p>
                                                <p class="p2-noResult">
                                                    {{
                                                        'casino_page.try_something_else' | transloco
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="play-something-container">
                                            <div class="fade-overlay"></div>
                                            <img src="assets/images/random-game-bg.png" alt="">
                                            <p>{{ 'casino_page.what_play' | transloco }}</p>
                                            <button
                                                class="play-something-button"
                                                (click)="playRandomGame()">
                                                {{ 'casino_page.play_something' | transloco }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            } @else {
                                @for (game of casinoGameList; track game) {
                                    <div class="game-container">
                                        <div
                                            class="casino__box"
                                            style="display: flex; flex-direction: column">
                                            <div class="game-img">
                                                @if (game.pragmaticLiveStatus === 'live' || game.pragmaticLiveStatus === 'offline') {
                                                    <div
                                                        class="live-status-badge"
                                                        [class.offline]="game.pragmaticLiveStatus === 'offline'">
                                                        {{ game.pragmaticLiveStatus === 'live' ? 'Live now' : 'Offline' }}
                                                    </div>
                                                }
                                                <div class="fav-icon">
                                                    <div class="fav-container">
                                                        @if (isFavourite(game.id)) {
                                                            <div class="icon-box">
                                                                <img
                                                                    src="assets/images/svg/star-yellow.svg" />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <img
                                                    (click)="
                                                        onGameSelectedHandler(
                                                            game.id,
                                                            iframeIndex,
                                                            game.subcategory
                                                        )
                                                    "
                                                    class="casino-cursor"
                                                    src="{{ game.imagePortrait }}" />

                                                <div class="play-button">
                                                    <div
                                                        class="button"
                                                        (click)="
                                                            onGameSelectedHandler(
                                                                game.id,
                                                                iframeIndex,
                                                                game.subcategory
                                                            )
                                                        ">
                                                        <img src="assets/images/svg/play-btn.svg" />
                                                    </div>

                                                    <div class="fav-icon">
                                                        <div class="fav-container">
                                                            <button
                                                                class="icon-box"
                                                                (click)="
                                                                    isFavourite(game)
                                                                        ? removeFromFavourites(game)
                                                                        : addToFavourites(game)
                                                                ">
                                                                @if (isFavourite(game)) {
                                                                    <img
                                                                        src="assets/images/svg/star-yellow.svg" />
                                                                } @else {
                                                                    <img
                                                                        src="assets/images/svg/star-casino.svg" />
                                                                }
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p
                                                (click)="
                                                    onGameSelectedHandler(
                                                        game.id,
                                                        iframeIndex,
                                                        game.subcategory
                                                    )
                                                "
                                                class="game-category">
                                                {{ game.category }}
                                            </p>
                                            @if (
                                                game.pragmaticLiveStatus === 'live' ||
                                                game.pragmaticLiveStatus === 'offline'
                                            ) {
                                                <div class="live-table-meta">
                                                    @if (game.pragmaticLiveDealer) {
                                                        <span>Dealer: {{ game.pragmaticLiveDealer }}</span>
                                                    }
                                                    @if (
                                                        game.pragmaticLiveMinBet !== null &&
                                                        game.pragmaticLiveMaxBet !== null
                                                    ) {
                                                        <span>
                                                            Limits: {{ game.pragmaticLiveMinBet }} - {{ game.pragmaticLiveMaxBet }}
                                                        </span>
                                                    }
                                                    @if (game.pragmaticLivePlayers !== null) {
                                                        <span>Players: {{ game.pragmaticLivePlayers }}</span>
                                                    }
                                                </div>
                                            }
                                            <p
                                                (click)="
                                                    onGameSelectedHandler(
                                                        game.id,
                                                        iframeIndex,
                                                        game.subcategory
                                                    )
                                                "
                                                class="game-name">
                                                {{ game.name }}
                                            </p>
                                        </div>
                                    </div>
                                }
                            }
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
